import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie } from '@fortawesome/free-solid-svg-icons';
import { Pie } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext'; // Corrected import path
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);



const StatusPedimentoCard = () => {
  const { data, isLoading } = useContext(DataContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const abiertoCount = data.filter(item => item.status_pedimento === "ABIERTO").length;
  const pagadoCount = data.filter(item => item.status_pedimento === "PAGADO").length;

  const chartData = {
    labels: ['ABIERTO', 'PAGADO'],
    datasets: [
      {
        label: 'Status Pedimento',
        data: [abiertoCount, pagadoCount],
        backgroundColor: ['#4B77BE', '#5CACEE'],
        hoverBackgroundColor: ['#354A5F', '#3E6B8E'],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: '#f8f8f8', // Near white color for labels inside the pie slices
        font: {
          size: 16, // Size might be larger for better visibility in pie slices
          family: 'Inter, sans-serif'
        },
        formatter: (value, ctx) => {
          // Display the value with the label from the chart data
          return `${value}`;
        }
      },
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 12,
            family: 'Inter, sans-serif',
            weight: '400',
            color: '#333'
          },
          boxWidth: 20,
          padding: 20,
        },
      },
      tooltip: {
        bodyFont: {
          size: 14,
          family: 'Inter, sans-serif',
          color: '#333'
        },
        titleFont: {
          size: 16,
          family: 'Inter, sans-serif',
          color: '#333'
        },
        backgroundColor: '#ffffff',
        borderColor: '#cccccc',
        borderWidth: 1,
        titleColor: '#333',
        bodyColor: '#333'
      }
    },
  };
  

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartPie} className="text-blue-600 mr-2" />
          Status Pedimento
        </h2>
      </div>
      <div className="flex-grow relative">
        <Pie data={chartData} options={options} />
      </div>
      <hr className="my-4" />
      <div>
        <div className="flex justify-between items-center text-sm mb-2">
          <span><strong>ABIERTO:</strong></span>
          <span>({abiertoCount})</span>
        </div>
        <div className="flex justify-between items-center text-sm">
          <span><strong>PAGADO:</strong></span>
          <span>({pagadoCount})</span>
        </div>
      </div>
    </div>
  );
  
};

export default StatusPedimentoCard;
